import React, { useEffect } from 'react'
import "./style.css"

import { homePageAssets } from '../../../assets/media'

const { img1, img2, img3 } = homePageAssets.sliderAssets

const CustomImageSlider = (customStyles, imgBundle) => {

    const images = [
        {
            imageUrl: img1,
            active: true
        },
        {
            imageUrl: img2,
        },
        {
            imageUrl: img3,
        },
    ]

    function slide(toIndex) {
        const itemsArray = Array.from(document.querySelectorAll(".carousel_item"));
        const itemActive = document.querySelector(".carousel_item__active");

        // check if toIndex exceeds the number of carousel items
        if (toIndex >= itemsArray.length) {
            toIndex = 0;
        }

        const newItemActive = itemsArray[toIndex];

        // start transition
        newItemActive.classList.add("carousel_item__pos_next");
        setTimeout(() => {
            newItemActive.classList.add("carousel_item__next");
            itemActive.classList.add("carousel_item__next");
        }, 20);

        // remove all transition class and switch active class
        newItemActive.addEventListener("transitionend", () => {
            itemActive.className = "carousel_item";
            newItemActive.className = "carousel_item carousel_item__active";
        }, {
            once: true
        });
    }


    function getItemActiveIndex() {
        const itemsArray = Array.from(document.querySelectorAll(".carousel_item"));
        const itemActive = document.querySelector(".carousel_item__active");
        const itemActiveIndex = itemsArray.indexOf(itemActive);
        return itemActiveIndex;
    }

    useEffect(() => {
        const interval = setInterval(() => {
            slide(getItemActiveIndex() + 1);
        }, 3000);


        return () => {
            clearInterval(interval)
        }
    }, [])



    return (
        <div className={`carousel carousel__fade ${customStyles}`}>
            <div className="carousel_inner">
                {
                    images.map((item, index) =>
                    (
                        <div key={item.imageUrl + index} className={`carousel_item ${item.active && "carousel_item__active"}`}>
                            <img src={item.imageUrl} alt="" className="carousel_img" />
                            <div className="carousel_caption">
                            </div>
                        </div>
                    )
                    )
                }

            </div>
        </div>


    )
}

export default CustomImageSlider